import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PaymentLink() {
	return (
		<div className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<h1 className="mb-10">Payment Link</h1>
			<div className="w-full h-[1px] bg-gray-400" />
			<div className="flex-1 md:flex md:flex-row pb-20 overflow-scroll">
				<div className="md:basis-4/5 w-full">
					<div className="mt-10">
						<h4>
							This feature enables business owners who do not own websites
							receive single or recurring payments from their customers
						</h4>
						<h4 className="mt-5">We have two types of Payment Links:</h4>
						<ul className="ml-5 lg:ml-10 mt-5 space-y-1">
							<li>
								1. <strong>Single Charge</strong> - a payment link where you can
								receive one time payments from customers
							</li>
							<li>
								2. <strong>Subscription Link</strong> - a payment link where you
								can create a charge cycle, and when a customer agrees and pays,
								their card is debited at the agreed number of times and
								interval. This is very useful for subscription based payments.
							</li>
						</ul>
						<h4 className="mt-5">
							The payment link can be published or unpublished. It is published
							at creation.
						</h4>
					</div>
					<div id="singlecharge"></div>
					<div className="mt-10">
						<h2 className="mb-5 font-bold">Single Charge</h2>
					</div>
					<div>
						<h2 className="text-xl font-semi-bold">Create Payment Link</h2>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require("../../assets/payment-link/option.png")}
								width={800}
								height={307}
								alt="toggletolive"
							/>
							<h4 className="italic">Fig 1.0</h4>
						</div>
					</div>
					<div className="mt-10">
						<h2 className="text-xl font-semi-bold">Single Payment Link</h2>
						<h4>
							You can create a fixed amount when creating a payment link, so
							that whenever a customer tries to pay you, they can only pay you
							the exact amount. This is useful for scenarios where you are
							creating a link that is tied to a product, an invoice, or
							generally trying to collect payments for customers that must be
							equal to a particular amount.
						</h4>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require("../../assets/payment-link/create-link.png")}
								width={500}
								height={697}
								alt="create-link"
							/>
							<h4 className="italic">Fig 1.1</h4>
						</div>
						<h4 className="mt-5">
							We also support dynamic amount options when creating your payment
							link. Whenever a customer tries to pay you, they can specify the
							amount they are paying. It is essential for scenarios where you
							are creating a link for donation.
						</h4>
					</div>
					<div className="mt-10">
						<h2 className="text-xl font-semi-bold">Payment Link Details</h2>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require("../../assets/payment-link/link-details.png")}
								width={800}
								height={392}
								alt="payment-details"
							/>
							<h4 className="italic">Fig 1.2</h4>
						</div>
					</div>
					<div className="mt-10">
						<h2 className="text-xl font-semi-bold">Edit Link Details</h2>
						<h4 className="mt-5">
							Merchant can edit a payment link to reflect a new amount or change
							from a fixed amount to a dynamic amount. You can also publish or
							unpublished a payment link at will.
						</h4>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require("../../assets/payment-link/edit-link.png")}
								width={500}
								height={654}
								alt="edit-link"
							/>
							<h4 className="italic">Fig 1.3</h4>
						</div>
					</div>
					<div className="mt-10">
						<h2 className="text-xl font-semi-bold">Delete Payment Link</h2>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require("../../assets/payment-link/delete-link.png")}
								width={700}
								height={392}
								alt="payment-details"
							/>
							<h4 className="italic">Fig 1.4</h4>
						</div>
					</div>

					<div id="subscriptionlink"></div>
					<div>
						<div className="mt-10">
							<h2 className="mb-5 font-bold">Suscription Link</h2>
						</div>
						<h4 className="mt-5">
							To create a subscription link that your customers can use to
							subscribe, you have to do the following:
						</h4>
						<ul className="ml-10 mt-5 space-y-1">
							<li>1. Create a plan</li>
							<li>2. Create a subscription link</li>
						</ul>
						<div id="createplan"></div>
						<div className="mt-10">
							<h2 className="mb-5 font-bold">Create a plan</h2>
							<h4 className="mb-5">
								Plan is the starting point for creating a subscription. This is
								what tells our system how much you are billing the customer, how
								often you want the billing to be, the duration to bill the
								customer and when the billing should commence.
							</h4>
							<h4 className="mb-5">
								To create a plan, visit spay plan route and follow the steps
								below:
							</h4>
							<h3 className="my-5">View Plans</h3>
							<h4>
								When you visit the plan route on the spay dashboard, you will
								see plans that you have created. If you have not created a plan,
								you will see an empty page
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/view-plans.png")}
									width={700}
									height={392}
									alt="viewplans"
								/>
								<h4 className="italic">Fig 2.0</h4>
							</div>
							<h3 className="my-5">Create Plans</h3>
							<h4>
								When you click on add plan button, a form to fill will be
								displayed. Plan Name, Amount, Set Limit, Interval and
								Description are required.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/create-plan.png")}
									width={700}
									height={392}
									alt="create plans"
								/>
								<h4 className="italic">Fig 2.1</h4>
							</div>
							<h3 className="my-5">View Created Plan</h3>
							<h4>
								When you have filled the form completely and you click on
								create, you will be redirected to see what you have created.
								This shows the details of what you have created and if you are
								not satisfied or you made a mistake, you can make correction(s)
								by clicking on edit plan.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/created-plan.png")}
									width={700}
									height={392}
									alt="created plans"
								/>
								<h4 className="italic">Fig 2.2</h4>
							</div>
						</div>
						<div id="createsub"></div>
						<div className="mt-10">
							<h2 className="mb-5 font-bold">Create a subscription link</h2>
							<h4 className="mb-5">
								There are two ways to create a subscription link: You can either
								create them from an existing plan or by creating a new plan.
							</h4>
							<h4 className="mb-5">
								To create a link that a user can use to subscribe, visit spay
								payment link route and follow the steps below:
							</h4>
							<h3 className="my-5">View Payment-links</h3>
							<h4>
								When you have clicked on the payment-link route, you will see
								payment-links you have created or an empty page if you have not.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/view-links.png")}
									width={700}
									height={392}
									alt="created plans"
								/>
								<h4 className="italic">Fig 2.3</h4>
							</div>
							<h3 className="my-5">Add Payment link</h3>
							<h4>
								To create a subscription link, click on the add payment link
								button. You will be shown with two options to select from. Click
								on the subscription option.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/option.png")}
									width={700}
									height={392}
									alt="created plans"
								/>
								<h4 className="italic">Fig 2.4</h4>
							</div>
							<h3 className="my-5">Subscription options</h3>
							<h4>
								When you click on subscription option, you will be shown three
								options: create a new plan, use an existing plan or cancel.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/select-plan.png")}
									width={700}
									height={392}
									alt="select plans"
								/>
								<h4 className="italic">Fig 2.5</h4>
							</div>
							<h3 className="my-5">
								Create subscription link with existing plan
							</h3>
							<h4>
								Once you select one of my existing plans, you will be shown a
								form to fill as in Fig 2.6. You will select from the plans you
								have created and give the link a name, which are required to
								create a subscription link. You can also fill in additional
								fields based on what you want. You can view them by clicking on
								show more.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/create-sub.png")}
									width={700}
									height={392}
									alt="create sub"
								/>
								<h4 className="italic">Fig 2.6</h4>
							</div>
							<h3 className="my-5">View created Payment-link details</h3>
							<h4>
								When you fill in the form and click on create, you will be
								redirected to see what you have created. This page usually
								contains the link that you can copy and send to your customer to
								subscribe. You can edit, delete or un-publish this link.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/link-details.png")}
									width={700}
									height={392}
									alt="link details"
								/>
								<h4 className="italic">Fig 2.7</h4>
							</div>
							<h3 className="my-5">
								Create a subscription link by creating a plan
							</h3>
							<h4>
								Likewise, you can create a subscription link from I want to
								create a new plan option in Fig 2.5. The below form, Fig 2.8,
								will be displayed and once it has been completely filled, you
								will be redirected to the Fig 2.7.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/create-plan.png")}
									width={700}
									height={392}
									alt="link details"
								/>
								<h4 className="italic">Fig 2.8</h4>
							</div>
							<h3 className="my-5">Created Payment Page</h3>
							<h4>
								Once the link is clicked, your customers will be asked to fill
								in the page in Fig 9 below and once they have successfully made
								payment, you will receive a mail and their details will also
								reflect on your dashboard.
							</h4>
							<div className="flex flex-col justify-center items-center mt-2">
								<img
									src={require("../../assets/payment-link/payment-page.png")}
									width={700}
									height={392}
									alt="link details"
								/>
								<h4 className="italic">Fig 2.9</h4>
							</div>
						</div>
					</div>

					<div className="mt-10 text-[12px]">WHAT&apos;S NEXT</div>
					<div>
						<NavLink to="/response-code">
							<div className="inline-flex items-center space-x-2">
								<h2 className="text-[#083d8c] text-[16px]">Response Code</h2>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth={1.5}
									stroke="currentColor"
									className="w-6 h-6"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
									/>
								</svg>
							</div>
						</NavLink>
					</div>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
						<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
							<h3>Table of Contents</h3>
							<a href="#singlecharge">
								<p className="text-sm mt-1 mb-2 text-[#637288]">
									Single Charge
								</p>
							</a>
							<a href="#subscriptionlink">
								<p className="text-sm mb-1 text-[#637288]">Subscription Link</p>
							</a>
							<a href="#createplan">
								<p className="text-sm mb-1 text-[#637288] ml-2">
									Create a Plan
								</p>
							</a>
							<a href="#createsub">
								<p className="text-sm mb-1 text-[#637288] ml-2">
									Create a subscription link
								</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
